import React from 'react';
import { API_BASE_URL } from '../utils/api';

function resolveViewHref(item) {
  const raw = item?.view_url || item?.url || '';
  if (!raw) return null;
  if (raw.startsWith('http://') || raw.startsWith('https://')) return raw;
  const base = API_BASE_URL.replace(/\/casc\/v1\/api\/?$/, '');
  return `${base}${raw.startsWith('/') ? raw : `/${raw}`}`;
}

export default function YumlEmissionLink({ emissions = [] }) {
  const list = Array.isArray(emissions) ? emissions : [];
  if (!list.length) return null;

  return (
    <div className="yuml-emissions">
      {list.map((item, idx) => {
        const href = resolveViewHref(item);
        const summary = item.summary || item.summary_text || '';
        const title = item.title || 'Formatted output';
        return (
          <div key={item.id || idx} className="yuml-emission-item">
            {summary && <p className="yuml-emission-summary">{summary}</p>}
            {href && (
              <a href={href} target="_blank" rel="noopener noreferrer" className="yuml-emission-link">
                View formatted output — {title}
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
}
